#### Job Posting features

We’ve extended [Job Posting] with two new features:

- Query the [nearest locations] for a geolocation.

  This enables you to suggest a SEEK location closest to an end user, or map to a SEEK location from an internal location hierarchy.

  ```graphql
  query ($first: Int, $geoLocation: GeoLocationInput!, $schemeId: String!) {
    nearestLocations(
      first: $first
      geoLocation: $geoLocation
      schemeId: $schemeId
    ) {
      contextualName
    }
  }
  ```

  ```json
  {
    "first": 2,
    "geoLocation": {
      "latitude": -37.840935,
      "longitude": 144.946457
    },
    "schemeId": "seekAnzPublicTest"
  }
  ```

- Query the [brands] available for StandOut and Premium ads.

  This enables you to include a brand preview and picker in your posting flow.

  ```graphql
  query ($after: String, $first: Int, $hirerId: String!) {
    advertisementBrandings(after: $after, first: $first, hirerId: $hirerId) {
      edges {
        node {
          name
        }
      }
    }
  }
  ```

  ```json
  {
    "after": null,
    "first": 2,
    "hirerId": "seekAnzPublicTest:organization:seek:93WyyF1h"
  }
  ```

[brands]: /use-cases/job-posting/branding
[job posting]: /use-cases/job-posting
[nearest locations]: /use-cases/job-posting/locations#nearestlocations
